// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chat-abandon__text[data-v-2cfa2ff8] {\n  margin-bottom: 5px;\n  color: #f04;\n  color: var(--color-error);\n  font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
